function init() {
  "ontouchstart" in window && (document.documentElement.className = document.documentElement.className + " touch"), $("html").hasClass("touch") || $(".parallax").css("background-attachment", "fixed"), $(window).resize(fullscreenFix), fullscreenFix(), $(window).resize(backgroundResize), $(window).focus(backgroundResize), backgroundResize(), $("html").hasClass("touch") || ($(window).resize(parallaxPosition), $(window).scroll(parallaxPosition), parallaxPosition());
}


function fullscreenFix() {
  var a = $("body").height();
  $(".content-b").each(function (i) {
    $(this).innerHeight() <= a && $(this).closest(".fullscreen").addClass("not-overflow")
  })
}

function backgroundResize() {
  var a = $(window).height();
  $(".background").each(function (i) {
    var t = $(this),
      e = t.width(),
      s = t.height(),
      o = t.attr("data-img-width"),
      n = t.attr("data-img-height"),
      r = o / n,
      c = parseFloat(t.attr("data-diff"));
    c = c ? c : 0;
    var l = 0;
    if (t.hasClass("parallax") && !$("html").hasClass("touch")) {
      l = a - s
    }
    n = s + l + c, o = n * r, e > o && (o = e, n = o / r), t.data("resized-imgW", o), t.data("resized-imgH", n), t.css("background-size", o + "px " + n + "px")
  })
}

function parallaxPosition(a) {
  var i = $(window).height(),
    t = $(window).scrollTop(),
    e = t + i,
    s = (t + e) / 2;
  $(".parallax").each(function (a) {
    var o = $(this),
      n = o.height(),
      r = o.offset().top,
      c = r + n;
    if (e > r && t < c) {
      var l = (o.data("resized-imgW"), o.data("resized-imgH")),
        d = 0,
        h = -l + i,
        u = n < i ? l - n : l - i;
      r -= u, c += u;
      var g = d + (h - d) * (s - r) / (c - r),
        w = o.attr("data-oriz-pos");
      w = w ? w : "50%", $(this).css("background-position", w + " " + g + "px")
    }
  })
}

export default init